import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromProduct from '../_reducers/product';

export const selectProductState = createFeatureSelector<fromProduct.ProductState>('products');

export const selectAllProducts = createSelector(selectProductState, fromProduct.selectAll);

export const selectProductEntities = createSelector(selectProductState, fromProduct.selectEntities);

export const selectProductById = (id: number) =>
  createSelector(selectProductEntities, (entities) => entities[id]);

export const selectProductTotal = createSelector(selectProductState, fromProduct.selectTotal);
